import React, { useEffect, useState } from 'react';
import '../assets/css/sideBar.css';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../configs/firebaseconfig';
import { useNavigate } from 'react-router-dom';

const SideBar = () => {
    const [projectsByYear, setProjectsByYear] = useState({});
    const navigate = useNavigate();
  
    useEffect(() => {
        const fetchProjects = async () => {
          const querySnapshot = await getDocs(collection(db, 'Projects'));
          const projects = querySnapshot.docs.map(doc => {
            const data = doc.data();
            if (data.date) {
              const date = new Date(data.date); 
              const year = date.getFullYear();
              return { ...data, year, id: doc.id };
            }
            return null; 
          }).filter(project => project !== null); 
    
          const groupedProjects = projects.reduce((acc, project) => {
            const { year } = project;
            if (!acc[year]) {
              acc[year] = [];
            }
            acc[year].push(project);
            return acc;
          }, {});
    
          setProjectsByYear(groupedProjects);
        };
    
        fetchProjects();
      }, []);
      const handleProjectClick = (projectId) => {
        navigate(`/projects/${projectId}`);
      };
    return (
        <div className="sidebar translate-x-0">
        {Object.keys(projectsByYear).map(year => (
          <div key={year}>
            <h2 className="year-heading">{year}</h2>
            <ul className="space-y-2">
            {projectsByYear[year].map((project, index) => (
              <li
                key={index}
                className="block cursor-pointer py-2 px-4 rounded hover:font-bold font-thin text-base"
                onClick={() => handleProjectClick(project.id)}
              >
                {project.name.toUpperCase()}
              </li>
            ))}
          </ul>
          </div>
        ))}
      </div>
    );
};

export default SideBar;